import isPlainObject from 'lodash.isplainobject'
import { object, array, NotRequiredArraySchema, ObjectSchema } from 'yup'

//25 is the Id for flag_creator key
const ID_FOR_FLAG_CREATOR_KEY = 25

const getValidationSchema = ({
  reworkAreas,
  categories,
}: {
  reworkAreas: {
    text: ReworkAreasInput
    translation: ReworkAreasInput
    design: ReworkAreasInput
    others: ReworkAreasInput
  }
  categories: string[]
}): ObjectSchema => {
  const schema: Record<
    string,
    Record<number, NotRequiredArraySchema<unknown, object>>
  > = { text: {}, translation: {}, design: {}, others: {} }

  Object.keys(reworkAreas)
    .filter(key => categories.includes(key))
    .forEach(key => {
      reworkAreas[key as ProjectCategory].forEach(item => {
        schema[key][item.id] = array().min(
          1,
          'Rework areas field must have at least 1 rework input.'
        )
      })
    })

  const result = object().shape({
    ...(categories.includes('text')
      ? {
          text: object()
            .shape(schema.text)
            .test(
              'is-selected-rework-area',
              'Please select at least 1 rework area.',
              (value: any) => {
                const { comment, attachments, ...rest } = value

                if (Object.keys(rest).length === 1) {
                  return !Object.keys(rest).includes(
                    `${ID_FOR_FLAG_CREATOR_KEY}`
                  )
                }
                return !(isPlainObject(rest) && Object.keys(rest).length === 0)
              }
            ),
        }
      : {}),
    ...(categories.includes('design')
      ? {
          design: object()
            .shape(schema.design)
            .test(
              'is-selected-rework-area',
              'Please select at least 1 rework area.',
              (value: any) => {
                const { comment, attachments, ...rest } = value

                if (Object.keys(rest).length === 1) {
                  return !Object.keys(rest).includes(
                    `${ID_FOR_FLAG_CREATOR_KEY}`
                  )
                }
                return !(isPlainObject(rest) && Object.keys(rest).length === 0)
              }
            ),
        }
      : {}),
    ...(categories.includes('translation')
      ? {
          translation: object()
            .shape(schema.translation)
            .test(
              'is-selected-rework-area',
              'Please select at least 1 rework area.',
              (value: any) => {
                const { comment, attachments, ...rest } = value

                if (Object.keys(rest).length === 1) {
                  return !Object.keys(rest).includes(
                    `${ID_FOR_FLAG_CREATOR_KEY}`
                  )
                }
                return !(isPlainObject(rest) && Object.keys(rest).length === 0)
              }
            ),
        }
      : {}),
    ...(categories.includes('others')
      ? { others: object().shape(schema.others) }
      : {}),
  })

  return result
}

export default getValidationSchema
